/**
 * project level usage analytics
 * https://mixpanel.com/api/app/projects/${projectId}/usage/data_queries/
 *
 * organization level usage analytics
 * https://mixpanel.com/organizations/${orgId}/usage/data_queries/
 */
import {apiClient} from 'common/util/api-client';

import {ChartDataEndpointPath, UsageAnalyticsApiResponse} from './usage-analytics-client-types';

class UsageAnalyticsClient {
  buildOrgEndpoint(orgId: number, endpointName: ChartDataEndpointPath) {
    return `/organizations/${orgId}/usage/${endpointName}/`;
  }

  buildProjectEndpoint(projectId: number, endpointName: ChartDataEndpointPath) {
    return `/api/app/projects/${projectId}/usage/${endpointName}/`;
  }

  async getChartData({
    usageContext,
    id,
    chartEndpoint,
  }: {
    usageContext: string;
    id: number;
    chartEndpoint: ChartDataEndpointPath;
  }) {
    let response = null;
    if (usageContext === `organization`) {
      response = await apiClient.get<UsageAnalyticsApiResponse>(this.buildOrgEndpoint(id, chartEndpoint));
    } else if (usageContext === `project`) {
      response = await apiClient.get<UsageAnalyticsApiResponse>(this.buildProjectEndpoint(id, chartEndpoint));
    } else {
      console.error(`invalid usage context. please use either organization or project`);
    }
    return response;
  }
}

export const usageAnalyticsClient = new UsageAnalyticsClient();
